import React, { useState } from "react";
import { useParams } from "react-router-dom";
import TeamService from "services/TeamService";
import * as Yup from "yup";
import { useToasts } from "react-toast-notifications";
import Loader from "components/Loader";
import Button from "components/CustomButton";
import CustomInput from "components/CustomInput/CustomInput";
import { faUserPlus } from "@fortawesome/free-solid-svg-icons";
import { ReactComponent as InvitationIcon } from "assets/img/icons/invitation_h.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ReactComponent as Delete } from "assets/img/icons/Delete.svg";
import { ReactComponent as CancelIcon } from "assets/img/icons/cancel.svg";
import { useFormik } from "formik";

export default function ({ teamId, teamName, closeDialog }) {
  const [loading, setLoading] = useState(false);
  const { addToast } = useToasts();
  const params = useParams();
  const formik = useFormik({
    initialValues: {
      email: "",
      emails: [],
      message: "",
    },
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: Yup.object().shape({
      email: Yup.string().email().required(),
    }),
    onSubmit: async (values) => {
      if (formik.values.emails.includes(values.email)) {
        // Email provided has already been added to list
        formik.setFieldValue("email", "");

        return;
      }

      formik.setFieldValue("emails", [...formik.values.emails, values.email]);
      formik.setFieldValue("email", "");
      formik.setFieldValue("message", "");
    },
  });

  const removeEmailFromList = (emailToRemove) => {
    formik.setFieldValue(
      "emails",
      formik.values.emails.filter((email) => {
        return email !== emailToRemove;
      })
    );
  };

  const sendInvites = () => {
    setLoading(true);
    if (formik.values.emails.length > 0) {
      try {
        TeamService.inviteMembers(
          teamId ?? params.teamId,
          formik.values.emails
        );

        formik.setFieldValue("emails", []);
        formik.setFieldValue("message", "Invitations were sent successfully");
        closeDialog();
        addToast("Invitation Send Successfully ", { appearance: "success" });
      } catch (error) {
        if (error.response) {
          formik.setFieldValue(
            "invitation_error",
            `Error occurred (${error.response.data.message}) invitations were not sent`
          );
        } else {
          formik.setFieldValue(
            "invitation_error",
            "Error occurred, invitations were not sent"
          );
        }
      }
    } else {
      formik.setFieldValue(
        "invitation_error",
        "Please add an email to send invitiatons."
      );
    }

    setLoading(false);
  };

  return (
    <div className="modal fade popup-modal" id="invite-members">
      <div className="modalHeader">
        <h5 className="text-center">Add/Invite A Member</h5>
        <Button
          type="button"
          onClick={closeDialog}
          buttonClass="btn-close"
          name={<CancelIcon className="cancel-icon" />}
        />
      </div>
      <div className="modalContent">
        <form noValidate onSubmit={formik.handleSubmit}>
          <CustomInput
            inputClass="full_w "
            formGroup={false}
            inputProps={{
              type: "email",
              placeholder: "Type Email Here",
              ...formik.getFieldProps("email"),
              error: formik.errors.email,
            }}
            endIcon={
              <FontAwesomeIcon
                onClick={formik.handleSubmit}
                onKeyDown={formik.handleSubmit}
                style={{ marginLeft: "-30px", cursor: "pointer" }}
                icon={faUserPlus}
                id="togglePassword"
              />
            }
          />
          {formik.values.invitation_error !== "" && (
            <div style={{ color: "red" }}>{formik.values.invitation_error}</div>
          )}
          <div className="searched-members p-3">
            <ul style={{ listStyleType: "none" }}>
              {formik.values.emails.map((email, index) => (
                <li key={index}>
                  <InvitationIcon style={{ width: "12px" }} className="me-1" />
                  {email}
                  <Delete
                    style={{ fill: "#575f6b", cursor: "pointer" }}
                    className="right"
                    onClick={() => removeEmailFromList(email)}
                  />
                </li>
              ))}
            </ul>
          </div>
          <Button
            type="button"
            onClick={sendInvites}
            buttonClass="btn grad_btn full_w"
            name={
              !loading ? "Send Invitations" : <Loader width={40} height={40} />
            }
            disabled={loading || (formik.values.emails.length < 1 && true)}
          />
        </form>
      </div>
    </div>
  );
}
